import type { ListingOfferCardProps } from 'app/types/listing-offer-card-props';
import { ListingOfferCardBase } from './listing-offer-card.base';

export const OFFER_CARD_HEIGHT = 100;
export const OFFER_CARD_WIDTH = '50%';
export const OFFER_CARD_GRID_WIDTH = 160;

function ListingOfferCardSmall(props: ListingOfferCardProps) {
  return <ListingOfferCardBase {...props} variant="small" />;
}

export { ListingOfferCardSmall };
